<div class="course-form-container">
  <h2>{{ isEditMode ? 'Edit Course' : 'Create New Course' }}</h2>

  <mat-spinner *ngIf="loading" diameter="50" class="spinner"></mat-spinner>

  <form [formGroup]="courseForm" (ngSubmit)="onSubmit()" *ngIf="!loading">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Subject ID</mat-label>
      <input matInput formControlName="subjectId" type="number" required>
      <mat-error *ngIf="courseForm.get('subjectId')?.hasError('required')">
        Subject ID is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Course Name</mat-label>
      <input matInput formControlName="name" required>
      <mat-error *ngIf="courseForm.get('name')?.hasError('required')">
        Course name is required
      </mat-error>
      <mat-error *ngIf="courseForm.get('name')?.hasError('minlength')">
        Course name must be at least 3 characters
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Course Code</mat-label>
      <input matInput formControlName="code" required>
      <mat-error *ngIf="courseForm.get('code')?.hasError('required')">
        Course code is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" rows="4"></textarea>
    </mat-form-field>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="endDate">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Max Students</mat-label>
      <input matInput formControlName="maxStudents" type="number" required>
      <mat-error *ngIf="courseForm.get('maxStudents')?.hasError('required')">
        Max students is required
      </mat-error>
    </mat-form-field>

    <div class="form-actions">
      <button mat-button type="button" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="courseForm.invalid || loading">
        {{ isEditMode ? 'Update' : 'Create' }} Course
      </button>
    </div>
  </form>
</div>
